








































































































































































































































































































































































































import {Component, Prop, Watch} from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay, CardForm } from '@/components/bwaff';
import TagApi from '@/services/rest/bemob/tag';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import tutorial from '@/components/tutorial/tutorial';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import dialogTargetMock from '@/components/dialogs/dialog-target-mock';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import { mixins } from 'vue-class-component';
import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import ApiServices from '@/services';
import TutorialMixin from '@/components/tutorial/tutorial-mixin';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import TrafficSourceApi from '@/services/rest/bemob/traffic-source';
import IntegrationsApi from  '@/services/rest/bemob/integrations';

const md5 = require('md5');

@Component({
  components: {
    FormOverlay,
    DialogForm,
    CardForm,
    ErrorAggregator,
    HeaderButtons,
    WorkspaceSelect,
    NoTagFound
  }
})
export default class TrafficSourceDialog extends mixins<PlanLimitsMixin,Form, ReportMixin, TutorialMixin>(PlanLimitsMixin, Form, ReportMixin, TutorialMixin) {
  @Prop({ default: {} })
  data: any;

  show: boolean = false;
  child: boolean = false;
  error: boolean = false;
  error_message: string = '';
  step: number = 1;
  tagApi: TagApi = new TagApi();
  trafficSourceApi: TrafficSourceApi = new TrafficSourceApi();
  integrationsApi: IntegrationsApi = new IntegrationsApi();
  errors: any[] = [];
  errorsControlActive: boolean = false;
  traffic_source_id: string = '';
  labelHelpExternalID = this.t('Use this parameter to track external unique IDs. This is typically used when you need to return an ID to the traffic source.')

  dialogTargetMock = dialogTargetMock();

  loading: boolean = false;
  chipsBase: string[] = [
    '+ {externalId}',
    '+ {payout}',
    '+ {campaignCpa}',
    '+ {campaignId}',
    '+ {trafficSourceId}',
    '+ {landingId}',
    '+ {offerId}',
    '+ {deviceType}',
    '+ {deviceVendor}',
    '+ {deviceModel}',
    '+ {browser}',
    '+ {browserVersion}',
    '+ {os}',
    '+ {osVersion}',
    '+ {country}',
    '+ {countryCode}',
    '+ {city}',
    '+ {region}',
    '+ {isp}',
    '+ {connectionType}',
    '+ {mobileCarrier}',
    '+ {ip}',
    '+ {referrerDomain}',
    '+ {lang}',
    '+ {transactionId}',
    '+ {clickId}',
    '+ {custom1}',
    '+ {custom2}',
    '+ {customN}',
    '+ {payout.CURRENCY}',
    '+ {status}',
    '+ {userAgent}',
    '+ {timestamp}',
    '+ {cet}',
    '+ {offerName}',
    '+ {offerCurrency}'
  ];
  chips: any[] = [];
  form: any = this.defaultForm();
  disabled = {
    extClickIdParam:false,
    extClickIdPlaceholder:false
  }

  @Watch('integrationType')
  integrationTypeChange(value, oldValue) {
    if(value==='facebook-conversions'){
      this.form.extClickIdParam = 'fbclid';
      this.form.extClickIdPlaceholder = '{fbclid}';
      this.disabled.extClickIdParam = true;
      this.disabled.extClickIdPlaceholder = true;
      this.labelHelpExternalID = this.t('fbclid is essential for conversion tracking between BeMob and Facebook.<br>If you wish to delete the value from the field, you will need to remove the integration with the Facebook from this template.');
      return
    }
    if(oldValue === 'facebook-conversions'){
      this.form.extClickIdParam = '';
      this.form.extClickIdPlaceholder = '';
      this.disabled.extClickIdParam = false;
      this.disabled.extClickIdPlaceholder = false;
      this.labelHelpExternalID = this.t('Use this parameter to track external unique IDs. This is typically used when you need to return an ID to the traffic source.')
    }
  }

  get modalTitle(){
    return this.t('Create traffic source')
  }
  
  defaultForm() {
    return {
      postbackUrl: '',
      status: 'active',

      extClickIdParam: '',
      extClickIdPlaceholder: '',
      costParam: '',
      costPlaceholder: '',

      custom1Param: '',
      custom1Placeholder: '',
      custom1Name: '',
      custom1Masking: false,
      custom2Param: '',
      custom2Placeholder: '',
      custom2Name: '',
      custom2Masking: false,
      custom3Param: '',
      custom3Placeholder: '',
      custom3Name: '',
      custom3Masking: false,
      custom4Param: '',
      custom4Placeholder: '',
      custom4Name: '',
      custom4Masking: false,
      custom5Param: '',
      custom5Placeholder: '',
      custom5Name: '',
      custom5Masking: false,
      custom6Param: '',
      custom6Placeholder: '',
      custom6Name: '',
      custom6Masking: false,
      custom7Param: '',
      custom7Placeholder: '',
      custom7Name: '',
      custom7Masking: false,
      custom8Param: '',
      custom8Placeholder: '',
      custom8Name: '',
      custom8Masking: false,
      custom9Param: '',
      custom9Placeholder: '',
      custom9Name: '',
      custom9Masking: false,
      custom10Param: '',
      custom10Placeholder: '',
      custom10Name: '',
      custom10Masking: false,

      trafficLossPercent: 0,

      trackImpressions: false,
      useTrafficLoss: false,

      integrationId: '',

      postbackSendConfirmStatus: true,
      postbackSendNewStatus: false,
      postbackSendChargebackStatus: false,
      postbackSendDeclineStatus: false,
      postbackPercent: 100
    }
  }
  oldHash: string = '';
  customPlaceholders = [
    {
      param: this.t('e.g. campaign_id'),
      placeholder: this.t('e.g. {campaign_id}'),
      name: this.t('e.g. Campaign ID')
    },
    {
      param: this.t('e.g. category_id'),
      placeholder: this.t('e.g. {category_id}'),
      name: this.t('e.g. Category ID')
    },
    {
      param: this.t('e.g. country'),
      placeholder: this.t('e.g. {country}'),
      name: this.t('e.g. Visitor country')
    },
    {
      param: this.t('e.g. format'),
      placeholder: this.t('e.g. {format}'),
      name: this.t('e.g. Format')
    },
    {
      param: this.t('e.g. site_id'),
      placeholder: this.t('e.g. {site_id}'),
      name: this.t('e.g. Site ID')
    },
    {
      param: this.t('e.g. src_hostname'),
      placeholder: this.t('e.g. {src_hostname}'),
      name: this.t('e.g. Source domain')
    },
    {
      param: this.t('e.g. variation_id'),
      placeholder: this.t('e.g. {variation_id}'),
      name: this.t('e.g. Variation ID')
    },
    {
      param: this.t('e.g. zone_id'),
      placeholder: this.t('e.g. {zone_id}'),
      name: this.t('e.g. Zone ID')
    },
    {
      param: this.t('e.g. parameter'),
      placeholder: this.t('e.g. {token}'),
      name: this.t('e.g. Token description')
    },
    {
      param: this.t('e.g. parameter'),
      placeholder: this.t('e.g. {token}'),
      name: this.t('e.g. Token description')
    }
  ]

  get trafficLossPercent() {
    return this.form.trafficLossPercent
  }

  set trafficLossPercent(val) {
    this.form.trafficLossPercent = Number((+val).toFixed(6).toString())
  }

  get useTrafficLoss() {
    return this.form.useTrafficLoss
  }

  set useTrafficLoss(val) {
    this.form.trafficLossPercent = 0
    this.form.useTrafficLoss = val
  }

  get introStepsDefault() {
    return {
      2: `<div class='introjs-tooltip__title'>${this.t('Traffic Source Settings')}</div><div class='introjs-tooltip__content'>${this.t('Specify name of traffic source')}</div>`,
      3: `<div class='introjs-tooltip__title'>${this.t('Traffic Source Settings')}</div><div class='introjs-tooltip__content'>${this.t('Create traffic source element')}</div>`
    };
  }

  get quickStartSection() {
    return 'traffic-sources';
  }

  get isActionsDisabled() {
    return !!(this.edit && this.aclReadOnly({
      workspaceId: this.form.workspaceId,
      id: this.traffic_source_id
    }));
  }

  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  getDefaultChips() {
    return this.chipsBase.map((e: any) => ({
      tag: e,
      disabled: false,
      title: e === '+ {payout}' ? this.t('With this token selected the conversion payout value will bе passed to the traffic source via the postback URL.') : ''
    }))
  }

  onBusOpenCreateTrafficSource(payload: any) {
    this.bus.emit('open-dialog', { name: 'CreateTrafficSource', data: payload });
  }

  touchedDictionary: { [type: string]: boolean } = {};

  changeDepends(value: any, ...depends: string[]) {
    depends.forEach((item, index) => {
      if(this.touchedDictionary[item]) {
        if(!value && !this.form[item]) {
          this.touchedDictionary[item] = false;
        }
      } else {
        const itemValue = index === 0 && value
          ? '{' + value + '}'
          : value;

        this.$set(this.form, item, itemValue);
      }
    });
  }

  touchDepends(name: string) {
    this.touchedDictionary[name] = true;
  }

  clickChip(item: any) {
    if (!item.disabled) {
      //@ts-ignore
      let textArea = this.$refs.textarea.$el.getElementsByTagName('textarea');
      let startPos = textArea[0].selectionStart,
        endPos = textArea[0].selectionEnd,
        cursorPos = startPos,
        tmpStr = textArea[0].value;
      this.form.postbackUrl = tmpStr.substring(0, startPos) + item.tag + tmpStr.substring(endPos, tmpStr.length);
      this.form.postbackUrl = this.form.postbackUrl.replace('+ ', '');
      this.changePostbackUrl();
      textArea[0].focus();
    }
  }

  changePostbackUrl() {
    let disItem: string;
    this.chips.forEach((item: any) => {
      disItem = item.tag.replace('+ ', '');

      item.disabled = !!(this.form.postbackUrl && this.form.postbackUrl.indexOf(disItem) + 1);
    })
  }

  changeCustomParameter(index: number) {
    this.form['custom' + index + 'Placeholder'] = '{' + this.form['custom' + index + 'Param'] + '}';

    if (this.form['custom' + index + 'Param'] == '') {
      this.form['custom' + index + 'Placeholder'] = '';
    }

    this.form['custom' + index + 'Name'] = this.form['custom' + index + 'Param'];
  }

  get integrationsOptions(){
    const result = this.$store.state.cache.integrations.data.map((item)=>{
      return {
        ...item,
        planLimits: this.integrationsPlanLimits(item.type)
      }
    })

    return [{
      id:'',
      name:'None'
    },...result];
  }

  subscribeEventBus(){
    this.$on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);
      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });

    //@ts-ignore
    if (!this.child)  {
      this.bus.on('open-create-traffic-source', this.onBusOpenCreateTrafficSource);
    } 
  }

  loadData() {
    this.$store.commit('loading', true);

    this.load()
      .then(() => {
        if (this.data.item) {
          this.form = {
            ...this.form,
            ...this.data.item,
          };
        }

        this.chips = this.getDefaultChips();
        this.changePostbackUrl();


        this.tutorial.form();
        this.oldHash = this.getCurrentHash();
        this.show = true;
      })
      .finally(() => this.$store.commit('loading', false));
  }
  
  async mounted() {
    this.subscribeEventBus();
    this.loadData()

    if(!this.$store.state.cache.tags['traffic-sources'].isUploaded){
      await this.tagApi.populateStoreCache({type:'traffic-sources'})
    }

    if(!this.$store.state.cache.integrations.isUploaded){
      await this.integrationsApi.populateStoreCache()
    }
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash() && !this.isActionsDisabled) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    if (!this.child)  {
      this.bus.off('open-create-traffic-source', this.onBusOpenCreateTrafficSource);
    }

    this.$emit('close');
  }

  get self() {
    return this;
  }

  get tutorial(){
    return tutorial(this);
  }
  
  processForm(form: any) {
    const preparedForm = {...form};
    if(this.integrationType==='facebook-conversions'){
      preparedForm.postbackUrl = '';
    }
    preparedForm.tags = preparedForm?.tags?.map((item)=>item?.id ? item.name : item);
    return preparedForm;
  }

  @Send()
  submit() {
    this.$store.commit('loading', true);

    return this.trafficSourceApi.postCreate(this.processForm(this.form))
      .then(async () => {
        await ApiServices.getUserProfile();

        this.oldHash = this.getCurrentHash();

        this.bus.emit('refresh-report');
        this.bus.emit('toast-success', this.t('Traffic Source has been saved'));

        this.close();
      })
      .finally(() => this.$store.commit('loading', false));
  }

  /* rewrite  method from mixin*/
  onChangeWorkspace(value: any) {}
  
  get integration(){
    return this.$store.state.cache.integrations.data.find(item=>item.id===this.form.integrationId);
  }
  get integrationType(){
    return this.integration?.type;
  }
  
  get showPlanLimitsWarning__integrations(){
    if(!this.integrationType) return;
    return this.hasPlanLimitsRestriction(this.integrationsPlanLimits(this.integrationType));
  }

  get showPlanLimitsWarning_tags() {
    return this.form.tags?.length && this.hasPlanLimitsRestriction('tagsTrafficSources')
  }

  clearTags(){
    this.form.tags = []
  }

  showPlanLimitsWarning_mask({key}){
    return this.form[key] && this.hasPlanLimitsRestriction('trafficSourceParamMasking')
  }

}
